export const TOWNSQUARE_CHANNEL_ICON = import.meta.env["VITE_TOWNSQUARE_CHANNEL_ICON"] || '🏛️';
export const DOWNTOWN_CHANNEL_ICON = import.meta.env["VITE_DOWNTOWN_CHANNEL_ICON"] || '🏠';
export const SLEEP_CHANNEL_ICON = import.meta.env["VITE_SLEEP_CHANNEL_ICON"] || '💤';
